// @flow
import * as React from 'react';
import Cleave from 'cleave.js/react';
import Wrapper from './InputCleave.style';
import iconAlert from '../../../../assets/icons/icon-alert.svg';

const InputCleave = (props) => {
  const { leftIcon, showAlert, ...rest } = props;
  const { creditCardNumber } = props;

  return (
    <Wrapper>
      <div className={showAlert ? 'input-line input-error' : 'input-line'}>
        <div className="input-img-container">
          <img className="input-img" alt="" src={leftIcon} />
        </div>
        <label className="floating-label floating">
          <Cleave {...rest} />
          <img className={showAlert ? 'alert-img' : 'alert-img-hide'} alt="" src={iconAlert} />
        </label>
      </div>
    </Wrapper>
  );
};

export default InputCleave;
